module.exports = __webpack_public_path__ + "img/CIRCUTOR.4435eb35.png";